import { gql } from '@parkchirp/api-client';

export const ASSIGN_PARKER_TO_RESERVED_SPACE = gql`
	mutation assignParkerToReservedSpace($input: AssignParkerToReservedSpaceInput!) {
		assignParkerToReservedSpace(input: $input)
	}
`;

export const REMOVE_PARKER_RESERVED_SPACE = gql`
	mutation removeParkerReservedSpace($input: RemoveParkerReservedSpaceInput!) {
		removeParkerReservedSpace(input: $input)
	}
`;

export const UPDATE_PARKER_RESERVED_SPACE = gql`
	mutation updateParkerReservedSpace($input: UpdateParkerReservedSpaceInput!) {
		updateParkerReservedSpace(input: $input)
	}
`;

export const DELETE_RESERVED_SPACE = gql`
	mutation deleteReservedSpace($input: DeleteReservedSpaceInput!) {
		deleteReservedSpace(input: $input)
	}
`;
